import { useState } from 'react';
import { usaCurrency } from '../../../utils/helpers';
import { InventoryAsset } from '../../../types';
import { Icon } from '../../../components/Atoms/Icon';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export interface InfoWindowContentProps {
  onClick: () => void;
  inventoryAssets: InventoryAsset[];
  locationName?: string;
  address?: string;
}

export const InfoWindowContent = ({ inventoryAssets, onClick, locationName, address }: InfoWindowContentProps) => {
  const [expandedAssetId, setExpandedAssetId] = useState<string | null>(null);
  const normalizedLocationName = locationName?.trim();
  const assetLocationName = inventoryAssets?.[0]?.addressInfo?.locationName?.trim();
  const normalizedAddress = address?.trim();
  const assetAddress = inventoryAssets?.[0]?.address;
  const displayLocationName = normalizedLocationName || assetLocationName || normalizedAddress || assetAddress;
  const displayAddress = normalizedAddress || assetAddress;

  const handleToggleExpand = (assetId: string) => {
    setExpandedAssetId((currentId) => (currentId === assetId ? null : assetId));
  };
  return (
    <div className="w-[380px] info-window text-black font-[400]">
      <div className="flex mb-[5px]">
        <Icon
          className="p-[4.5px] ml-[32.5px] mr-[10px]"
          type="pin"
        />
        <div className="text-[14px] font-medium tracking-normal leading-[18px] truncate">{displayLocationName}</div>
      </div>
      <button
        className="ml-[51.5px] flex mb-[15px] text-[12px] leading-[15px] text-indigo"
        onClick={onClick}>
        {displayAddress}
      </button>
      <hr />
      <div className="mt-[15px] ml-[15px] mr-[10px] text-left">
        <div className="flex text-[10px] leading-3 text-grey-4 tracking-[0.4px]">
          <div className="w-2/5 py-2 font-medium">SERVICE</div>
          <div className="w-2/5 py-2 font-medium">PROVIDER</div>
          <div className="w-1/5 py-2 font-medium">MRC</div>
        </div>
        {inventoryAssets.map((asset) => {
          const isPointToPoint = ['Point to Point', 'Point-to-Point'].includes(asset?.product?.name);
          const isExpanded = expandedAssetId === asset.id;
          return (
            <div
              key={asset.id}
              className="leading-[13px] text-black text-[12px]">
              <div className={`flex ${isExpanded ? '' : 'border-b'} border-gray-2 items-center`}>
                <div className="w-2/5 py-2 font-normal">{asset?.product?.name}</div>
                <div className="w-2/5 py-2 font-normal">{asset?.supplier?.name}</div>
                <div className="w-1/5 py-2 font-normal flex items-center">
                  {usaCurrency.format(asset.mRC)}
                  {isPointToPoint && (
                    <button
                      className="hover:bg-gray-100"
                      onClick={() => handleToggleExpand(asset.id)}
                      aria-expanded={isExpanded}
                      aria-label="Toggle Details"
                      aria-controls={`p2p-details-${asset.id}`}>
                      {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                    </button>
                  )}
                </div>
              </div>
              {isPointToPoint && isExpanded && (
                <div
                  id={`p2p-details-${asset.id}`}
                  className="border-b border-gray-2 py-2 text-[11px] leading-4">
                  <div className="flex">Location A: {asset?.locationAText || 'N/A'}</div>
                  <div className="flex mt-1">Location Z: {asset?.locationZText || 'N/A'}</div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
